import {
  ModuleNavTemplate,
  PageTemplate,
  ProgramNavTemplate,
} from '@efdigital/ll-addon-content';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import {
  pageTemplateParts,
  programTemplateParts,
  resourceTemplateParts,
} from '@efdigital/ll-admin-v2/components/parts.gts';
import ContentBreadcrumb from '@efdigital/ll-admin-v2/components/programs/content-breadcrumb.gts';
import { EditPageWidgets } from '@efdigital/ll-admin-v2/components/programs/edit-page-widgets.gts';
import { Sidebar } from '@efdigital/ll-admin-v2/components/sidebar/sidebar.gts';
import type { PageContext } from '@efdigital/ll-admin-v2/lib/page-manager';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortContentModulePageRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module/page';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { pageTitle } from 'ember-page-title';

interface ModulePageSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortContentModulePageRoute>;
    controller: unknown;
  };
}

const parts = programTemplateParts;
const partsForPage = {
  ...pageTemplateParts,
  ...resourceTemplateParts,
};

function pageContext(
  model: ModelFrom<ProgramsProgramCohortContentModulePageRoute>
): PageContext {
  return {
    type: 'module',
    programId: model.program.id as string,
    cohortId: model.cohort.id as string,
    moduleId: model.module.id as string,
  };
}

const Template: TemplateOnlyComponent<ModulePageSignature> = <template>
  {{pageTitle "Page"}}

  <ContentBreadcrumb @model={{@model}} />

  <div class="mb-5">
    <EditContext as |context|>
      <Sidebar>
        <:content>
          <ProgramNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @parts={{parts}}
          />
          <ModuleNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @module={{@model.module}}
            @parts={{parts}}
          >
            <PageTemplate
              @page={{@model.page}}
              @section={{hash path=@model.page.slug}}
              @parts={{partsForPage}}
            />
          </ModuleNavTemplate>
        </:content>
        <:sidebar>
          <div class="px-3 py-4">
            <EditPageWidgets
              @item={{@model.page}}
              @context={{context}}
              @pageContext={{pageContext @model}}
              class="mb-5"
            />
          </div>
        </:sidebar>
      </Sidebar>
    </EditContext>
  </div>
</template>;

export default Template;
